import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface RemoveCategoryInterface {
  categoryId: string;
}

export const useRemoveCategory = () => {
  const mutate = useMutation(({ categoryId }: RemoveCategoryInterface) => {
    return get(`/external-api/remove_category/${categoryId}`);
  });

  return mutate;
};

export default useRemoveCategory;
